const SvgOffsetTime = (props) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M10.125 5.063H8.363v4.151l-2.738 2.56 1.245 1.164 3.255-3.043z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M16.325 13.186c-1.876 3.287-5.803 5.01-9.61 3.935C2.906 16.047.462 12.52.582 8.74M1.69 4.817C3.568 1.53 7.494-.193 11.301.882c3.808 1.075 6.253 4.6 6.132 8.381"
        stroke="currentColor"
      />
    </g>
  </svg>
)

export default SvgOffsetTime
